import React from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment";
import { IMAGE_URL } from "src/network/endpoints";

const OrderCancellationRequestMessage = ({ message, onViewOrder, getCancelledItemCount }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 2.5,
        width: "100%",
        minWidth: "280px",
        maxWidth: "380px",
        padding: "2px 0",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: 1.5,
          backgroundColor: "#f3f4f6",
          border: "1px solid #e5e7eb",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          overflow: "hidden",
        }}
      >
        {message?.orderId?.imageVideo &&
        Array.isArray(message.orderId.imageVideo) &&
        message.orderId.imageVideo.length > 0 ? (
          <img
            src={`${IMAGE_URL}${message.orderId.imageVideo[0]}`}
            alt="order item"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        ) : (
          <Typography
            variant="caption"
            sx={{
              color: "#6b7280",
              fontSize: "11px",
              textAlign: "center",
              fontWeight: 500,
            }}
          >
            image placeholder
          </Typography>
        )}
      </Box>

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "80px",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 0.3,
            minHeight: "20px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: "14px",
              fontWeight: 600,
              color: "#000000",
              textTransform: "lowercase",
              lineHeight: 1.2,
              flex: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            cancel items
          </Typography>

          <Typography
            variant="caption"
            sx={{
              fontSize: "11px",
              color: "#6b7280",
              fontWeight: 500,
              flexShrink: 0,
              ml: 1,
            }}
          >
            {message?.createdAt
              ? moment(message.createdAt).fromNow()
              : "20 mins"}
          </Typography>
        </Box>

        <Typography
          variant="body2"
          sx={{
            fontSize: "14px",
            color: "#000000",
            mb: 0.2,
            fontWeight: 500,
          }}
        >
          <span style={{ color: "#7C3AED", fontWeight: 700 }}>
            {getCancelledItemCount()}
          </span>
          : items
        </Typography>

        <Box sx={{ mb: 0.2, flex: 1 }}>
          <Typography
            variant="body2"
            sx={{
              fontSize: "12px",
              color: "#6b7280",
              textDecoration: "underline",
              cursor: "pointer",
              textTransform: "lowercase",
              fontWeight: 500,
            }}
            onClick={() => onViewOrder?.(message)}
          >
            view order
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default OrderCancellationRequestMessage;
